<template>
  <div class="bg-cover bg-center text-white pt-10 pb-12 h-64 lg:h-420px" :style="{ backgroundImage: 'url(' + mastheadImage + ')'}">
    <div class="flex flex-wrap items-center max-w-2xl m-auto px-10 mb-0 md:mb-10 justify-between">
      <div class="mb-10">
        <a href="/" class="router-link-active font-light tracking-wide text-lg flex flex-col text-white no-underline">
          <ReimaginePortalIcon responsive />
        </a>
      </div>
      <a class="self-start text-base sm:text-xl no-underline text-white font-light" target="_blank" href="https://help.letsreimagine.org/hc/en-us/sections/360008463452-Creating-Your-Account-and-Public-Profile">
        <span class="sr-only">(opens in a new tab)</span> Help Center
      </a>
    </div>
    <div class="flex max-w-2xl m-auto pt-0 lg:pt-24 pb-2">
      <div class="w-full h-full md:w-3/5">
        <h1 class="mb-3 text-4.5xl md:text-5xl leading-tight pl-4">
          {{ heading }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import ReimaginePortalIcon from "../../images/icons/ReimaginePortalIcon.vue";
const routeSettings = {
  register: {
    masthead: '/img/mastheads/account-bg.png',
    heading: 'Join the community',
  },
  'register-create-profile': {
    masthead: '/img/mastheads/profile-bg.png',
    heading: 'Share your story'
  },
  'register-jedi-pledge': {
    masthead: '/img/mastheads/jedi-bg.png',
    heading: 'Create inclusive spaces',
  }
};

export default {
  name: "RegisterPageHeader",
  components: {ReimaginePortalIcon},
  computed: {
    mastheadImage() {
      return routeSettings[this.$route.name].masthead;
    },
    heading() {
      return routeSettings[this.$route.name].heading;
    }
  }
}
</script>

<style scoped>

</style>